export class HeroCarousel extends window.BAO.Carousel.Element {
  static get requiredElements () {
    return super.requiredElements
  }

  /**
   * Give a small “nudge” on load for mobile so users notice
   * the carousel is interactive.
   */
  static useNudgeOnLoad (element) {
    return slider => {
      slider.on('created', () => {
        if (
          window.BAO.MediaBreakpoints.isXsViewport &&
          element.getAttribute('data-hero-carousel-mobile-nudge-on-load') ===
            'true'
        ) {
          const details = slider.track && slider.track.details
          if (!details) return

          const currentIndex = details.rel
          const slideCount = details.slides.length
          if (slideCount <= 1) return

          window.setTimeout(() => {
            const nextIndex = (currentIndex + 1) % slideCount

            slider.moveToIdx(nextIndex)

            window.setTimeout(() => {
              slider.moveToIdx(currentIndex)
            }, 400)
          }, 1000)
        }
      })
    }
  }

  initialiseCarousel () {
    const autoplaySpeed = parseInt(
      this.getAttribute('data-hero-carousel-autoplay-speed'),
      10,
    )

    const autoplayStatus = this.getAttribute('data-hero-carousel-autoplay')

    // Safely get optional controls
    const dots = this.els.dot?.elements ?? [] // if no dots, pass empty array
    const next = this.els.next?.element // if no arrows, these are undefined
    const previous = this.els.previous?.element

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        ...(autoplayStatus === 'true'
          ? [
              window.BAO.Carousel.useAutoplay(autoplaySpeed, {
                pauseOnHover:
                  this.getAttribute('data-hero-carousel-pause-on-hover') ===
                  'true',
              }),
            ]
          : []),
        window.BAO.Carousel.useDots(dots),
        window.BAO.Carousel.useArrows({ next, previous }),
        HeroCarousel.useNudgeOnLoad(this),
      ],
    )
  }
}

if (!customElements.get('hero-carousel')) {
  customElements.define('hero-carousel', HeroCarousel)
}
